<template>
  <div class="template">
    <img class="top-picc-2" src="@/assets/images/template/picc-icon2.jpg" />
    <div class="redline"></div>
    <div class="top-title">人 车 失 联 服 务 凭 证</div>
    <div class="num-con2">
      凭证编号:
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="p-content">
            兹证明
            <span class="key">“青岛鑫诚泰网络科技有限公司”</span>
            销售的人车失联服务由中国人寿财产股份有限公司（下称该公司）承保，服务细节如下：
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">一.服务期限:</div>自保单生效之日起{{swapper(selectYear)}}年有效。在保险期限内，如发生车辆转让，原保险责任立即中止。
          <!-- {{getendTime($formatTimeCN2(showDate.saleslip.installtime))}}零时起至{{getendTime($formatTimeCN2(showDate.saleslip.pendtime))}}二十四时止。在保险期限内，如发生车辆转让，原保险责任立即中止，且应立即通知本公司办理变更手续。变更手续办理的次日零时起，保险责任恢复，但原保单中止日期不变。保险责任中止期间本公司不负责赔偿。如再次购买本保险，被保险机动车价格以当年该机动车车损险定价计算。 -->
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.服务范围:</span>
          <div class="p-content">
          中华人民共和国境内（港、澳、台除外），被服务车辆安装青岛鑫诚泰网络科技有限公司销售的车载定位系统且该车辆手续齐全、合法有效。</div><div class="p-content">
被服务客户应为18周岁（含）至65周岁（含），身体健康、能正常工作或正常生活，向商业银行或农村信用合作社联合社等金融机构申请贷款并签订借款合同自然人。</div><div class="p-content">
车辆有符合金融机构规定的贷款产品；贷款年限最长不超过3年；保险金额不得低于被保险人车辆贷款金额。
</div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.保障责任:</div>
          <div class="p-content">
            失联：在服务期间或服务凭证载明的追溯期内，因定位系统无法正常定位以致失联，且用户未按照（借款合同）的约定履行付款义务且超过60天赔款等待期后车辆仍无法定位找回，造成金融机构或银行贷款损失，由青岛鑫诚泰在责任限额内负责赔偿。
            </div><div class="p-content">
盗抢：在服务期间或服务凭证载明的追溯期内，因定位系统无法正常定位，造成已安装定位系统的车辆整车被盗抢或抢夺，经60天侦破期后仍无法找回，由车主在车辆丢失后24小时内提出损害赔偿请求。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">四.赔付标准:</div>
          <div class="p-content">
            赔偿限额：最高不超过50万</div><div class="p-content">
盗抢：出险车辆未购买车损险的，按被盗车辆投保金额（即购车发票金额）100%在赔偿限额内进行赔付。
</div><div class="p-content">
失联：以出险客户未偿还贷款本金为限。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.除外责任:</div>
          <div class="p-content">1. 不接受非金融特许经营许可证的机构贷款合同投保。</div><div class="p-content">
2. 租赁性质的服务车辆承租人同时失踪。</div><div class="p-content">
3. 由车主承担的对其雇员的赔偿责任。</div><div class="p-content">
4. 因产品缺陷造成车主所有、照管或控制的财产的损失。</div><div class="p-content">
5. 产品仍在制造或销售场所，尚未转移至用户或消费者手中时所造成的损失赔偿责任。</div><div class="p-content">
6. 产品本身的损失及被保险人因收回、更换或修理有缺陷产品造成的损失和费用。</div><div class="p-content">
7. 在港、澳、台地区以及中华人民共和国境外使用产品，发生的损害赔偿和费用，以及向上述地区的法院、仲裁机构提起诉讼或仲裁而产生的赔偿和费用。</div>
          <!-- <div class="p-content">1、被保险机动车发生整车盗抢的，本保险对机动车盗抢险免赔部分在赔偿限额内进行差额赔偿；
          如客户未购买相关保险，被保险机动车发生整车盗抢的，按照盗抢险赔付标准赔付；</div>
          <div class="p-content">2、被保险机动车发生整车自燃的，本保险对机动车自燃险免赔部分在赔偿限额内进行差额赔偿；
          如客户未购买相关保险，被保险机动车发生整车自燃的，按照自燃险赔付标准赔付；</div>
          <div class="p-content">3、保险责任事故发生后，赔偿出险车辆当年所缴纳的保险费用包括：交强险、车损险、第三者责任险；</div>
          <div class="p-content">4、保险责任事故发生后，车主得到所投保保险公司商业车险赔偿后，赔偿出险车辆车主代步费5000元；</div>
          <div class="p-content">
            赔付限额最高
            <span class="p-underline">{{showDate.saleslip.compensation*1.2}}</span>元。
          </div>
          <div class="p-content">
            特别声明：若安装该产品的车辆为金融机构贷款所购，未还清贷款时，同意优先向第一受益人:
            <span class="p-underline">{{showDate.saleslip.firstbeneficiaryname}}</span>，支付保险赔款。
          </div> -->
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">六.索赔材料:</div>
          <div class="p-content">
         盗抢材料：a.本服务凭证，购买及安装产品的凭证；b. 购车发票，车辆登记证书，c.《出险通知书》、《权益转让书》；d.、县以上公安刑侦部门出具的盗抢案件证明及保险人要求的其他正当材料。
         </div><div class="p-content">
失联材料：a.本服务凭证，购买及安装本产品的凭证；b. 缴费凭证；《汽车贷款合同》；c.系统的未偿还本金截图；d.出险车辆的定位系统最后一次定位截图；e. 相关机关立案证明和受理回执；f.《权益转让书》；h. 保险人要求的其他正当材料（金融公司营业执 照，客户身份证，车辆行驶证等）。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">七.特别约定:</div>
            &nbsp;&nbsp;<span class="p-underline">{{showDate.saleslip.firstbeneficiaryname}}</span>&nbsp;本凭证第一受益人，未经其书面同意，本凭证不得被退保、批改（不影响第一受益权益的批改除外）；如发生保障服务赔偿责任时，保障人按第一受益人的权益转让书支付保险赔款。
        </td>
      </tr>
    </table>
<div class="personal-title">车主信息</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">车主姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>固定电话</td>
        <td colspan="2"></td>
        <td>移动电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="2">{{showDate.saleslip.address}}</td>
        <td>保费金额</td>
        <td colspan="2">{{showDate.saleslip.policyamount}}</td>
      </tr>
      <tr>
        <td>车牌号码</td>
        <td>{{showDate.saleslip.carnum}}</td>
        <td width="130">车架号</td>
        <td>{{showDate.saleslip.frame}}</td>
        <td width="130">车辆登记日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>发动机号</td>
        <td>{{showDate.saleslip.enginenum}}</td>
        <td>产品编号</td>
        <td>{{showDate.saleslip.devicenum}}</td>
        <td>安装日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.installtime)}}</td>
      </tr>
      <tr>
        <td>安装地点</td>
        <td colspan="3">{{showDate.saleslip.installaddress}}</td>
        <td>安装人员</td>
        <td>{{showDate.saleslip.installman}}</td>
      </tr>
    </table>
    <p class="tips">
    服务商：青岛鑫诚泰网络科技有限公司</p>
    <p class="tips">
签&nbsp;章：
      </p>
    <p class="tips">
特别声明：事故发生后，车主应当在24小时内向商业险保险公司及交管部门报案，同时致青岛鑫诚泰全国统一客户热线：4006601517进行备案。
</p>
    
    <!-- <img class="inis2-3" src="@/assets/images/inis2-2.png" alt /> -->
    <img class="inis-1" src="@/assets/images/inis.png" alt />
  </div>
</template>

<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch (n) {
        case 1:
          return "壹";
        case 2:
          return "贰";
        case 3:
          return "叁";
        case 4:
          return "肆";
        case 5:
          return "伍";
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/s11.vue